


























































import Vue from "vue";
import * as api from "@/api";
import { getEnums } from "@/api/custom-simulation";

const FilterEnumText = {
    major: "专业大类",
    grade: "年级"
};
export default Vue.extend({
    data() {
        return {
            list: [] as { label: string; items: { key: string; value: string }[] }[],
            searchInput: ""
        };
    },
    computed: {
        selectedFilter(): {
            grade: string;
            major: string;
        } {
            return this.$store.state.customSimulationModule.selectedFilter;
        }
    },
    methods: {
        handleSearch() {
            this.$store.dispatch("customSimulationModule/getSimulationList", {
                filter: this.searchInput,
                major: this.selectedFilter.major,
                grade: this.selectedFilter.grade
            });
        },
        selectFilter(data) {
            this.$store.commit("customSimulationModule/setSelectedFilter", {
                ...this.selectedFilter,
                ...data
            });
            this.handleSearch();
        },
        getLable(key: string) {
            return FilterEnumText[key];
        }
    },
    async mounted() {
        const majorRes = await getEnums({ group: "major" });
        const gradeRes = await getEnums({ group: "grade" });
        if (!api.error(majorRes) && !api.error(gradeRes)) {
            this.$set(this.list, 0, {
                label: "major",
                items: majorRes.data[0].txt.split(",").map(v => ({ key: v, value: v }))
            });
            this.$set(this.list, 1, {
                label: "grade",
                items: gradeRes.data[0].txt.split(",").map(v => ({ key: v, value: v }))
            });
        }
    }
});
